import React from 'react';
import MemberRail, { RAIL_WIDTH } from './MemberRail';
import FeedbackLauncher from '../feedback/FeedbackLauncher';

/**
 * The signed-in frame: nav rail on the left, page content beside it.
 *
 * The content offset reads RAIL_WIDTH from MemberRail rather than repeating the
 * literal, so the two can't drift apart.
 */
export default function MemberShell({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="min-h-screen"
      style={{
        backgroundColor: 'var(--m-bg)',
        color: 'var(--m-ink)',
        fontFamily: 'var(--melio-sans)',
      }}
    >
      <MemberRail />
      <main className="min-h-screen" style={{ paddingLeft: RAIL_WIDTH }}>
        {children}
      </main>
      <FeedbackLauncher />
    </div>
  );
}
